import { render } from "./CompanyLogo.vue?vue&type=template&id=08da225f"
import script from "./CompanyLogo.vue?vue&type=script&lang=js"
export * from "./CompanyLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__